(ns hai.ui.components.form.select.multi-select
  (:require
   [hai.ui.components :as c]
   [hai.ui.components.form.input :as input]
   [hai.ui.rf-sugar :refer [>e defevent defevent-fx defsub]]
   [humbleai.belt.dom :as dom]
   [humbleai.belt.vector :refer [toggle-membership]]
   [medley.core :refer [assoc-some]]))

(defn ->form-id
  [?select]
  ;; TODO using the :form.field/form-id and :form.field/attr to calculate the :form/id when we have
  ;; the select field (e.g. in parent form) or the :form/id if we're in the select's own render
  ;; where the form in scope is the backing form of the select field. This needs to be re-thought,
  ;; possibly stop stripping keys during coercion.
  (if (map? ?select)
    (or (:form/id ?select)
        [(:form.field/form-id ?select)
         (:form.field/attr ?select)])
    ?select))

(defn ->form
  [db ?select]
  ;; TODO see `->form-id`
  (get-in db [:forms (->form-id ?select)]))

(defn assoc-in-form
  [db ?form & pairs]
  (apply update-in db [:forms (->form-id ?form)] assoc pairs))

(defn dissoc-in-form
  [db ?form & ks]
  (apply update-in db [:forms (->form-id ?form)] dissoc ks))

(defn pills-core
  [{:as form
    {:multi-select.render/keys [pill]} :select/render
    {{:form.field/keys [current-value]} :multi-select/selected} :form/fields}]
  (into [:<>]
        (map (partial pill form))
        current-value))

;; TODO move to select NS
(defevent :select/show-options
  [db ?select]
  (assoc-in db [:forms (->form-id ?select) :select/show-options?] true))

;; TODO move to select NS
(defevent :select/hide-options
  [db ?select]
  (assoc-in db [:forms (->form-id ?select) :select/show-options?] false))

(defsub :select/show-options?
  [?id
   form <- [:form ?id]]
  (get form :select/show-options?))

(defevent :select/set-active-option
  [db ?select option]
  (assoc-in db [:forms (->form-id ?select) :select/active-option] option))

(defsub :select/active-option
  [?select
   select <- [:form ?select]]
  (get select :select/active-option))

(defevent-fx :select/set-active-option-to
  [{:keys [db]} ?select direction]
  (let [{:select/keys [active-option]
         {:table/keys [rows]} :form/current-value :as form} (->form db ?select)
        current-index (.indexOf rows active-option)
        index (case direction
                :previous (dec current-index)
                :next (inc current-index)
                :first 0)
        index-bounded (mod index (count rows))
        active-option (get rows index-bounded)]
    {:dispatch [:select/set-active-option ?select active-option]}))

(defevent-fx :select/toggle-options
  [{:keys [db]} ?select options]
  (let [{:as form {:multi-select/keys [selected]} :form/current-value} (->form db ?select)
        selected (reduce toggle-membership selected options)]
    {:dispatch-n [[:select/hide-options ?select]
                  [:form.field/set-value! form :multi-select/selected selected]
                  [:form.field/set-value! form :table/rows []]]}))

(defevent-fx :select/toggle-option
  [{:keys [db]} ?select option]
  {:dispatch [:select/toggle-options ?select [option]]})

(defevent-fx :select/remove-last-selected
  [{:keys [db]} ?select]
  (let [{{:multi-select/keys [selected]} :form/current-value} (->form db ?select)]
    {:dispatch [:select/toggle-options ?select [(last selected)]]}))

(defevent-fx :select/toggle-active-option
  [{:keys [db]} ?select]
  (let [{:as form :select/keys [active-option]} (->form db ?select)]
    {:dispatch [:select/toggle-option ?select active-option]}))

(defsub :select/active-option?
  [?select
   option
   active-option <- [:select/active-option ?select]]
  (= active-option option))

(defevent-fx :select/highlight-last-selected
  [{:keys [db]} ?select]
  (let [{{:as form :multi-select/keys [selected]} :form/current-value} (->form db ?select)]
    {:db (assoc-in-form db ?select :multi-select/highlighted-selected (last selected))}))

(defevent-fx :multi-select/remove-highlighted
  [{:keys [db]} ?select]
  (let [{{:multi-select/keys [selected]} :form/current-value
         :multi-select/keys [highlighted-selected]} (->form db ?select)]
    {:db (dissoc-in-form db ?select :multi-select/highlighted-selected)
     :dispatch [:select/toggle-option ?select highlighted-selected]}))

(defsub :multi-select.pill/highlighted?
  [db pill]
  (let [{:form.field/keys [current-value]} pill
        form (->form db pill)
        {:multi-select/keys [highlighted-selected]} form]
    (= current-value highlighted-selected)))

(defsub :multi-select/highlighted
  [?id
   select <- [:form ?id]]
  (get select :multi-select/highlighted-selected))

;; TODO replace select-input* with this
(defn select-input**
  [{:as select
    :select/keys [input-ref]
    {:table/keys [search]} :form/fields
    ;; TODO these can be passed form the multi-select props, this is not ideal
    :input/keys [render]
    :form.field.input/keys [on-key-down auto-focus?]}]
  [input/field
   (assoc-some search
               :style {:width "100%" :min-width "100px"}
               :ref input-ref
               :on-focus (fn [_]
                           (dom/select-input input-ref)
                           (>e [:select/show-options select]))
               :type :text
               ;; TODO these can be passed form the multi-select props, this is not ideal
               :form.field.input/on-key-down on-key-down
               :form.field.input/auto-focus? auto-focus?
               :input/render render)])

(defn select-input*
  [{:select/keys [input-ref]
    {{:form.field/keys [set-value!]} :table/search} :form/fields}]
  (let [on-change (comp set-value! dom/->value)]
    (fn inner
      [{:as select {{:form.field/keys [placeholder]} :table/search} :form/fields}]
      [c/TextFieldRoot
       {:ref input-ref
        :autoComplete :off
        :on-change on-change
        :on-focus (fn [_]
                    (dom/select-input input-ref)
                    (>e [:select/show-options select]))
        :placeholder placeholder
        :type :text}])))

(defn select-input
  [select]
  [:f> select-input* select])

(defn pill-close
  [{{{:form.field/keys [set-value! current-value]} :multi-select/selected} :form/fields}
   option
   content]
  (let [close-on-click (fn [_] (set-value! (toggle-membership current-value option)))]
    [:div
     {:on-click close-on-click}
     content]))

(defn option-core
  [{:as select
    {{:form.field/keys [set-value! current-value]} :multi-select/selected} :form/fields
    {option-render :select.render/option
     disabled-reason :select.render/disabled-reason} :select/render}
   option]
  (let [disabled? (boolean (when disabled-reason (disabled-reason option)))
        ;; A disabled option (e.g. a contact with no email) stays visible and
        ;; hoverable — so its tooltip can explain why — but must be inert. A
        ;; click-phase guard is too late: the dropdown is dismissed earlier, on
        ;; `pointerdown` (the focusable option steals focus from the search input
        ;; → blur, and radix runs its outside-interaction check on pointerdown).
        ;; So swallow the pointer early: `preventDefault` on the click is what
        ;; actually keeps the dropdown open -- the field's click-outside handler
        ;; honours `defaultPrevented` (React's `stopPropagation` can't stop that
        ;; native listener). `preventDefault` on pointer/mouse-down additionally
        ;; keeps focus on the search input.
        swallow (fn [e] (.preventDefault e))]
    [:div.option-core
     (cond-> {:on-mouse-enter (fn [_] (>e [:select/set-active-option select option]))}
       disabled?       (assoc :on-pointer-down swallow
                              :on-mouse-down swallow
                              :on-click swallow)
       (not disabled?) (assoc :on-click (fn [_] (set-value! (toggle-membership current-value option)))))
     [option-render select option]]))
